export const sxStyle = {
  /* --- CONTENEDORES --- */
  boxStepsTextFirst: {
    ml: { xs: '0.5vw', md: '1.1vw' },
    mt: { xs: '0.5vh', md: '-10px' },
    width: '100%',
  },

  boxStepsText: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    ml: { xs: '3vw', md: '25px' },
    mt: { xs: '0px', md: '-10px' },
    width: '100%',
  },

  /* --- TEXTOS DESKTOP (md+) --- */
  titleSteps: {
    fontSize: { md: '24px' },
    fontWeight: 600,
    color: 'inherit',
    display: { xs: 'none', md: 'block' },
  },

  subtitleStepsBase: {
    color: 'inherit',
    fontWeight: 300,
    fontSize: '14px',
    display: { xs: 'none', md: 'block' },
  },

  /* --- TEXTOS MOBILE (xs-sm) --- */
  subtitleStepsMobile: {
    display: { xs: 'block', md: 'none' },
    color: 'inherit',
    fontWeight: 600,
    ml: { xs: '10px', sm: 0 },

    /* tamaño base */
    fontSize: '16px',

    /* ajustes finos por device */
    '@media (min-width:320px)': { fontSize: '12px' },
    '@media (min-width:360px)': { fontSize: '14px' },
    '@media (min-width:375px)': { fontSize: '15px' },
    '@media (min-width:414px)': { fontSize: '17px' },
    '@media (min-width:480px)': { fontSize: '18px' },
    '@media (min-width:540px)': { fontSize: '18px' },
  },
};
